
import { Component, Prop, Vue } from 'vue-property-decorator';

import { ClaimCheckTerms as TermsModel } from '@/models';

@Component
export default class ClaimCheckTerms extends Vue {
	@Prop({
		type: Object,
		default() {
			return new TermsModel();
		},
	})
	public terms!: TermsModel;

	public get hasTerms(): boolean {
		return (
			!!(Array.isArray(this.terms.header) && this.terms.header.length) ||
			!!(Array.isArray(this.terms.footer) && this.terms.footer.length) ||
			!!this.terms.body
		);
	}

	public get hasHeader(): boolean {
		return !!(Array.isArray(this.terms.header) && this.terms.header.length);
	}

	public get hasFooter(): boolean {
		return !!(Array.isArray(this.terms.footer) && this.terms.footer.length);
	}
}
